import { apiClient } from '@/services/ApiClient.js'

export default {
  getFinancialBank(query) {
    return apiClient
      .get('banks', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getBillBank(query) {
    return apiClient
      .get('banks', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createBank(bank) {
    return apiClient
      .post('banks', bank)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateBank(bankId, bank) {
    return apiClient
      .patch('banks/' + bankId, bank)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  uploadLogo(bankId, form) {
    let formData = new FormData()
    formData.append('logo', form.file)

    return apiClient
      .postForm('banks/' + bankId + '/upload-logo', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getBanks(params) {
    return apiClient
      .get('banks', { params })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getBankAccounts(params) {
    return apiClient
      .get('bank-accounts', { params })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getBankAccountsByBank(bankId) {
    return apiClient
      .get('banks/' + bankId + '/bank-accounts')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getBankAccount(bankId, bankAccountId) {
    return apiClient
      .get('banks/' + bankId + '/bank-accounts/' + bankAccountId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getBank(id) {
    return apiClient
      .get('banks/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getPayment(id) {
    return apiClient
      .get('orders/' + id + '/payments')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  editBanks(orderId, paymentId, params) {
    return apiClient
      .patch('orders/' + orderId + '/payments/' + paymentId, params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createBankAccount(bankId, params) {
    return apiClient
      .post('banks/' + bankId + '/bank-accounts', params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateBankAccount(bankId, bankAccountId, params) {
    return apiClient
      .patch('banks/' + bankId + '/bank-accounts/' + bankAccountId, params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteBankAccount(bankId, bankAccountId) {
    return apiClient
      .delete('banks/' + bankId + '/bank-accounts/' + bankAccountId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getCorrespondentBanks(bankId) {
    return apiClient
      .get(`banks/${bankId}/correspondent-banks`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getCorrespondentBank(bankId, correspondentBankId) {
    return apiClient
      .get(`banks/${bankId}/correspondent-banks/${correspondentBankId}`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createCorrespondentBank(bankId, data) {
    return apiClient
      .post(`banks/${bankId}/correspondent-banks`, data)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateCorrespondentBank(bankId, correspondentBankId, data) {
    return apiClient
      .patch(`banks/${bankId}/correspondent-banks/${correspondentBankId}`, data)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteCorrespondentBank(bankId, correspondentBankId) {
    return apiClient
      .delete(`banks/${bankId}/correspondent-banks/${correspondentBankId}`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
